import { Save } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../../Models/User';
import datas from "../../../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../../../Functions/Security/Crypter';
import { FormSection, FormActions, PickerList, useAlert, Spin, Input, Textarea, Button } from '../../ui';


export interface ConfirmationDialogRawProps {
    classes: Record<'paper', string>;
    id: string;
    keepMounted: boolean;
    value: string;
    open: boolean;
    onClose: (value?: string) => void;
}

export interface Ticket {
    numeroFile: string,
    guichet: string,
    agence: String
}

const FormGroup = (props: { codePromo?: string; onSaved?: () => void }) => {
    // USER TOKEN
    const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert()

    const { register, handleSubmit, setValue, reset } = useForm()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [habilitations, setHabilitations] = useState<string[]>([])
    const [rows, setRows] = useState([])

    useEffect(() => {
        loadHabilitation()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function loadHabilitation() {
        setLoading(true)

        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Habilitation,
            headers: {
                'Authorization': authHeader(),
            }
        };
        axios.request(config)
            .then((response) => {
                setLoading(false)
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    const habilitation: any = []

                    res.Result.map((h: any) => {
                        habilitation.push({ id: h.CodeHabi, libelle: h.Libelle, },)
                    })
                    setRows(habilitation)
                } else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            });
    }
    const onSubmit = async (data: any) => {
        // alert(user.CodeU)

        if (habilitations.length > 0) {

            setLoading(true)
            // Groupe { Roleid, Libelle, CreatedBy, Habilitations } — Habilitations = chaîne JSON
            data = { ...data, "Habilitations": JSON.stringify(habilitations), "CreatedBy": user.CodeU }

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: env.API_BASE_URL + datas.API_LINKs.Groupe,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                },
                data: Crypter.encrypt(JSON.stringify(data))
            };

            axios.request(config)
                .then((response) => {
                    setLoading(false)
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value
                    if (res.StatutCode == 200) {
                        //localStorage.setItem("loadQmGuichet", "1")
                        alert.success(res.Message)
                        reset()
                        setHabilitations([])
                        props.onSaved?.()
                    } else {
                        alert.warning(res.Message)
                    }
                })
                .catch((error) => {
                    setLoading(false)
                    alert.error(error.message)
                })
        }
        else {
            alert.warning("Veillez sélectionner les habilitations.")
        }
    }

    const pickerItems = rows.map((r: any) => ({ id: r.id, label: r.libelle }));


    return (
        <>
            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormSection title="Identification du groupe" subtitle="Code et libellé du groupe d'utilisateurs">
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("RoleId")}
                            required
                            type='text'
                            label={'Code Groupe'}
                            placeholder={"Entrez le code groupe"} />
                        <Textarea
                            onKeyUp={() => setIsOk(false)}
                            {...register("Libelle")}
                            required
                            rows={3}
                            label={'Libellé'}
                            placeholder={"Entrez le libellé du groupe"} />
                    </FormSection>

                    <FormSection title="Habilitations" subtitle="Sélectionnez les habilitations du groupe">
                        <div className="full">
                            <PickerList
                                items={pickerItems}
                                selected={habilitations}
                                onChange={(ids) => setHabilitations(ids)}
                                emptyText="Aucune habilitation disponible"
                            />
                        </div>
                    </FormSection>

                    <FormActions>
                        <Button variant='secondary' type='submit' startIcon={<Save size={16} />}>Enregistrer</Button>
                    </FormActions>
                </form>
            </Spin>
        </>
    );
};

export default FormGroup;
